module.exports = __webpack_public_path__ + "img/vertical_7_7_2.05201207.png";